module.exports = __webpack_public_path__ + "img/linkedin.9e75ae54.svg";